// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1bNu80sGb0yYKX0Lmy1aYz","form":"_2iPBEhAr38EIPc_9Kw-Ued"};